var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6526 6.89453H12.7366C12.5374 6.89453 12.3479 6.99023 12.2307 7.1543L9.1604 11.4121L7.76978 9.48242C7.65259 9.32031 7.46509 9.22266 7.26392 9.22266H6.3479C6.22095 9.22266 6.14673 9.36719 6.22095 9.4707L8.65454 12.8457C8.71203 12.9259 8.78782 12.9913 8.87563 13.0364C8.96343 13.0815 9.06072 13.1051 9.15943 13.1051C9.25814 13.1051 9.35543 13.0815 9.44323 13.0364C9.53103 12.9913 9.60682 12.9259 9.66431 12.8457L13.7776 7.14258C13.8538 7.03906 13.7795 6.89453 13.6526 6.89453Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C5.16797 1.25 1.25 5.16797 1.25 10C1.25 14.832 5.16797 18.75 10 18.75C14.832 18.75 18.75 14.832 18.75 10C18.75 5.16797 14.832 1.25 10 1.25ZM10 17.2656C5.98828 17.2656 2.73438 14.0117 2.73438 10C2.73438 5.98828 5.98828 2.73438 10 2.73438C14.0117 2.73438 17.2656 5.98828 17.2656 10C17.2656 14.0117 14.0117 17.2656 10 17.2656Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ab054248b33da60c558c5981b1333b4d.svg";
export { ForwardRef as ReactComponent };